import application from 'application/application';

import template from './processes-create.template.html';

import controller from './processes-create.controller';

application

	.config(['$stateProvider', $stateProvider => {

		$stateProvider

			.state('root.default.processes.processesCreate', {
				url: '/novo-processo',
				views: {
					'default@root.default': {
						templateUrl: template,
						controller
					}
				},
				data: {
					documentTitle: 'Novo Processo',
					displayName: 'Novo Processo'
				}
			});

	}]);
